import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";

const CONTENT = {
  realtor: {
    tag: "For Realtors",
    title: "Read this to start 🍭",
    lead: "You're 30 seconds away from never chasing a pre-approval again.",
    steps: [
      "Head to the My Lenders tab and add a new lender — your go-to, or any (even multiple!) lenders you work with.",
      "Send them the sign-up link. They get a cheeky 30-second sign-up — that's it.",
      "For every client you share, your lender simply drops that client's loan estimate into their backend portal.",
      "Boom — now you send polished pre-approvals from your fingertips, any time of day, 7 days a week. No phone calls, no waiting.",
    ],
    close: "Welcome to having your life back. 🙌",
  },
  lender: {
    tag: "For Lenders",
    title: "Read this to start 🍭",
    lead: "Set it up once and win back your nights and weekends.",
    steps: [
      "Finish your Lender Profile — logo, headshot, NMLS & contact — so everything's co-branded to you.",
      "Go to the Agents tab and send your realtors a 30-second sign-up email.",
      "Load each client's buying power and upload their loan estimate to the backend — just once.",
      "Now your realtors send their own pre-approvals — while you handle loan estimates and stay in control — without bogging you down in the middle of your kid's soccer practice. You're alerted every time.",
    ],
    close: "Welcome to getting your life back. ⚽ 🏦",
  },
};

export default function StartHereModal({ open, isLender, onClose }) {
  const c = isLender ? CONTENT.lender : CONTENT.realtor;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-md bg-[#0d0d0d] border border-[#ff3b30]/25 text-white p-0 overflow-hidden max-h-[90vh] overflow-y-auto"
        data-testid="start-here-modal"
      >
        <div className="px-6 pt-6 pb-5">
          <DialogTitle className="sr-only">{c.title}</DialogTitle>
          <DialogDescription className="sr-only">{c.lead}</DialogDescription>
          <div className="text-[11px] tracking-[0.22em] uppercase text-[#ff6a61] font-bold">{c.tag}</div>
          <h2 className="font-display text-2xl tracking-tight mt-1.5 leading-tight">{c.title}</h2>
          <p className="text-white/85 text-sm leading-snug font-medium mt-3">{c.lead}</p>

          <ol className="mt-4 space-y-3">
            {c.steps.map((s, i) => (
              <li key={i} className="flex gap-3">
                <span className="h-6 w-6 rounded-full bg-[#ff3b30] text-white text-xs font-bold flex items-center justify-center shrink-0">
                  {i + 1}
                </span>
                <span className="text-[13px] text-white/75 leading-snug pt-0.5">{s}</span>
              </li>
            ))}
          </ol>

          <p className="mt-4 font-display text-base text-white/90 leading-snug">{c.close}</p>

          <Button
            onClick={onClose}
            data-testid="start-here-dismiss"
            className="mt-5 w-full h-11 bg-[#ff3b30] hover:bg-[#ff5147] text-white font-semibold rounded-xl"
          >
            Let's go
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
